import { Navigate } from "react-router-dom";
import { Home } from "./components/Home";
import Page404 from "./Page404";
import Catalog from "./components/Catalog";
import ProductPage, {ProductPageParent} from "./components/ProductPage";
import UserInfo from "./components/UserInfo";
import EventPage from "./components/EventPage";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path:"/catalog/:id",
    element: <ProductPageParent/>
  },
  {
    path: '/catalog',
    element: <Catalog/>
  },
  {
    path: '/fetch-data',
    element: <Navigate to="/event" replace/>
  },
  {
    path: '/info',
    element: <UserInfo/>
  },
  {
    path:"/event",
    element: <EventPage/>
  },
  {
    path:'/*',
    element: <Page404/>
  },
];

export default AppRoutes;
